import { v2GuidedSystemBuilderSchema } from '@ecomm/shared-components'
import type { TypeOf } from '@simplisafe/ewok'

export const guidedSystemBuilderSchema = v2GuidedSystemBuilderSchema

export type GuidedSystemBuilderSchema = TypeOf<
  typeof v2GuidedSystemBuilderSchema
>
